// extracted by mini-css-extract-plugin
export default {"main":"App_main__5VZ13","container":"App_container__4L7Vo","container__title":"App_container__title__+uxlq","container__loading":"App_container__loading__9aLFD"};